import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';

export const SnackbarFilterLabelAvatar = styled(Avatar)`
  background-color: #2185d0;
  width: 24px;
  height: 24px;
  display: inline-flex;
  margin-right: 5px;
`;
